// import '@hotwired/turbo-rails'
import { Turbo } from '@hotwired/turbo-rails'
import Turn from '@domchristie/turn'
import './member-portal/controllers'
import { fireworks } from './fireworks'

Turn.start()

Turbo.StreamActions.fireworks = function () {
  fireworks()
}
